export class CommonClasses {
}


export class radioGroupOption {
    title?: string;
    text?: string;
    value: any;
}